import React from 'react';
import { useSelector } from 'react-redux';
import PagosAdmin from './widgets/PagosAdmin';
import PagosPropiedad from './widgets/PagosPropiedad';
import WelcomeWidget from './widgets/WelcomeWidget';
import Tareas from './widgets/Tareas';
import Alertas from './widgets/Alertas';
import Mensajes from './widgets/Mensajes';
import ComunicadoModal from '../comunicado/ComunicadoModal';

function Dashboard(props) {


    const logguedUserData = useSelector(state => state.common.logguedUserData);

    const permRoles = [... new Set(logguedUserData?.permissions?.map(p => p.rol_id))];
    const adminRol = true; //(permRoles.includes(1) || permRoles.includes(2));
    const otherRol = (permRoles.find(p => p > 2))?.length > 0;

    return (
        <div className="container-xxl flex-grow-1 container-p-y">
            <WelcomeWidget />
            <div className='d-flex align-items-start row-cols-2 mb-3'>
                {
                    adminRol &&
                    <PagosAdmin />
                }
                {
                    otherRol &&
                    <PagosPropiedad />
                }
                <Mensajes />
            </div>
            <div className='d-flex align-items-start row-cols-2'>
                <Tareas />
                <Alertas />
            </div>
            <ComunicadoModal />


        </div>
    );
}

export default Dashboard;